import { TicketType, userType } from "../../DTO";
import { Api } from "../api";

export const ShowTicket = (user: userType, ticketId: number | string) => {
    return new Promise<{ ticket: TicketType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: `tickets/${ticketId}`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) => resolve({ ticket: data.data }))
            .catch((err: any) => reject(err?.data?.message ?? err));
    });
};
